export const INVISIBLE_CHEVRON = (
  <div style={{ width: 'var(--dimension-xs)', height: 'var(--dimension-xs)' }} />
);

export const DISABLED_TOOLTIP_DELAY = 1000;

export const FIELD_KEYS = {
  min: 'minimum',
  max: 'maximum',
};

export const ERROR_MESSAGES = {
  requiredMin: 'Minimum is required',
  requiredMax: 'Maximum is required',
  mustBeNumberMin: 'Minimum must be a number',
  mustBeNumberMax: 'Maximum must be a number',
  minTooLow: 'Minimum must be at least 0',
  minExceedsMax: 'Minimum cannot be greater than maximum',
  maxTooLow: 'Maximum must be greater than 0',
  maxTooHigh: 'Maximum cannot exceed 99',
  maxBelowMin: 'Maximum cannot be less than minimum',
  maxExceedsChoices: 'Maximum cannot exceed number of available choices',
  minBelowIndividualMin: 'Minimum must be at least the individual minimum',
  maxBelowIndividualMax: 'Maximum must be at least the individual maximum',
};
